import Image from 'next/image'
import React from 'react'

const TopBanner = () => {
    return (
        <div className="relative w-full h-8.75 bg-[#1B365E] flex items-center justify-center gap-8 sm:gap-2">
            <p className="font-lato text-[#D9D9D9] text-[8px] sm:text-[14px] leading-5 font-normal tracking-[0.28px]">
                Vous avez une question ?  
            </p>

            {/* <div className='flex items-center gap-2'>
                <div className="flex relative">
                    <Image
                        src="/assets/icons/phone.svg"
                        alt="Téléphone"
                        title="Téléphone"
                        width={20}
                        height={20}
                        className='sm:w-5 sm:h-5 w-4 h-4'
                    />
                </div>

                <a href="tel:+33600000000" title="Nous appeler" className="font-lato font-bold text-[8px] sm:text-[15px] leading-tight tracking-[0.3px] text-white hover:opacity-80 transition-opacity">
                    + 33 6 00 00 00 00
                </a>
            </div> */}
        </div>
    )
}

export default TopBanner